import { render, staticRenderFns } from "./WidgetProgression.vue?vue&type=template&id=d475d80a&"
import script from "./WidgetProgression.vue?vue&type=script&lang=js&"
export * from "./WidgetProgression.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports